var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import getAllProperties from "../../utils/object/getAllProperties.js";
import RefsManager from "./RefsManager.js";
class EventsManager {
  constructor(rootElement, base) {
    __publicField(this, "__rootElement");
    __publicField(this, "__base");
    __publicField(this, "__methodsCache", /* @__PURE__ */ new Map());
    __publicField(this, "__rootElementHandler", {
      handleEvent: (event) => {
        const normalizedEventName = EventsManager.normalizeName(event.type);
        const method = `on${normalizedEventName}`;
        this.__base[method](event);
      }
    });
    __publicField(this, "__refsHandler", {
      handleEvent: (event) => {
        const ref = event.currentTarget;
        const refName = RefsManager.normalizeRefName(ref.dataset.ref);
        const normalizedRefName = EventsManager.normalizeName(refName);
        const normalizedEventName = EventsManager.normalizeName(event.type);
        const method = `on${normalizedRefName}${normalizedEventName}`;
        let index = 0;
        if (Array.isArray(this.__base.$refs[refName])) {
          index = this.__base.$refs[refName].indexOf(ref);
        }
        this.__base[method](event, index);
      }
    });
    __publicField(this, "__childrenHandler", {
      handleEvent: (event) => {
        const child = event.currentTarget;
        let childName;
        let index = 0;
        const childrenManager = this.__base.$children;
        childrenManager.registeredNames.find((name) => {
          if (childrenManager[name].includes(child)) {
            childName = name;
            index = childrenManager[name].indexOf(child);
            return true;
          }
          return false;
        });
        const normalizedRefName = EventsManager.normalizeName(childName);
        const normalizedEventName = EventsManager.normalizeName(event.type);
        const method = `on${normalizedRefName}${normalizedEventName}`;
        const args = Array.isArray(event.detail) ? event.detail : [];
        this.__base[method](...args, index, event);
      }
    });
    Object.defineProperties(this, {
      __rootElement: {
        enumerable: false,
        writable: false,
        value: rootElement
      },
      __base: {
        enumerable: false,
        writable: false,
        value: base
      },
      __methodsCache: {
        enumerable: false,
        writable: false,
        value: this.__methodsCache
      },
      __rootElementHandler: {
        enumerable: false,
        writable: false,
        value: this.__rootElementHandler
      },
      __refsHandler: {
        enumerable: false,
        writable: false,
        value: this.__refsHandler
      },
      __childrenHandler: {
        enumerable: false,
        writable: false,
        value: this.__childrenHandler
      }
    });
  }
  __manageRef(name, elements, mode = "add") {
    const action = `${mode}EventListener`;
    const methods = this.__getEventMethodsByName(name);
    methods.forEach((method) => {
      const event = this.__getEventNameByMethod(method, name);
      elements.forEach((element) => element[action](event, this.__refsHandler));
    });
  }
  bindRef(name, elements) {
    this.__manageRef(name, elements);
  }
  unbindRef(name, elements) {
    this.__manageRef(name, elements, "remove");
  }
  __manageChild(name, instance, mode = "add") {
    const action = mode === "add" ? "$on" : "$off";
    const methods = this.__getEventMethodsByName(name);
    methods.forEach((method) => {
      const event = this.__getEventNameByMethod(method, name);
      instance[action](event, this.__childrenHandler);
    });
  }
  bindChild(name, instance) {
    this.__manageChild(name, instance);
  }
  unbindChild(name, instance) {
    this.__manageChild(name, instance, "remove");
  }
  __manageRootElement(mode = "add") {
    const modeMethod = `${mode}EventListener`;
    const methods = this.__getEventMethodsByName();
    const { emits = [] } = this.__base.__config;
    methods.forEach((method) => {
      const event = this.__getEventNameByMethod(method);
      const target = emits.includes(event) ? this.__base : this.__rootElement;
      target[modeMethod](event, this.__rootElementHandler);
    });
  }
  bindRootElement() {
    this.__manageRootElement();
  }
  unbindRootElement() {
    this.__manageRootElement("remove");
  }
  __getEventNameByMethod(method, name = "") {
    const normalizedName = EventsManager.normalizeName(name);
    const regex = new RegExp(`^on${normalizedName}([A-Z].*)$`);
    const [, event] = method.match(regex);
    return EventsManager.normalizeEventName(event);
  }
  __getEventMethodsByName(name = "") {
    const normalizedName = EventsManager.normalizeName(name);
    const regex = new RegExp(`^on${normalizedName}[A-Z].*$`);
    const key = regex.toString();
    let methods = this.__methodsCache.get(key);
    if (!methods) {
      methods = Array.from(getAllProperties(this.__base, [], (method) => regex.test(method)).reduce((set, [method]) => set.add(method), /* @__PURE__ */ new Set()));
      this.__methodsCache.set(key, methods);
    }
    return methods;
  }
  static normalizeName(name) {
    return name.replace(/[A-Z]([A-Z].*)/g, (c) => c.toLowerCase()).replace(/[^a-zA-Z\d\s:]/g, " ").replace(/(^\w|\s+\w)/g, (c) => c.trim().toUpperCase()).trim();
  }
  static normalizeEventName(name) {
    return name.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`).replace(/^-/, "");
  }
}
export {
  EventsManager as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
